import * as React from 'react';
import Svg, {Rect, Path, G} from 'react-native-svg';
interface IProps {
  width?: number;
  height?: number;
}
const PlusSignIcon = ({width = 44, height = 44}: IProps) => (
  <Svg width={width} height={height} viewBox="0 0 44 44" fill="none">
    <G filter="url(#filter0_d_13348_24179)">
      <Rect
        x="9"
        y="9"
        width="26"
        height="26"
        rx="13"
        fill="white"
        shape-rendering="crispEdges"
      />
      <Rect
        x="9.5"
        y="9.5"
        width="25"
        height="25"
        rx="12.5"
        stroke="#CFCFCF"
        shape-rendering="crispEdges"
      />
      <Path
        d="M25.875 21.1641V23.125H18.0781V21.1641H25.875ZM23.0469 18.0781V26.3594H20.9141V18.0781H23.0469Z"
        fill="#111111"
      />
    </G>
  </Svg>
);
export default PlusSignIcon;
